import React from 'react'
import { YearMonthFns } from '../utils/datetime'

export interface useYearMonthPickerResult {
  transitionState: 'none' | 'toNext' | 'toPrev' | 'init'
  onTransitionComplete(): unknown

  goToNextYear(): unknown
  goToPreviousYear(): unknown

  yearMonthOptions: string[]

  focus: string

  onChange(yearMonth: string): unknown
  value: string | null
  setFocus(yearMonth: string | null): void
}

export interface useYearMonthPickerProps {
  /** format like 2024-01 */
  value: string | null
  onChange(yearMonth: string): unknown
}

export function useYearMonthPicker({ value: yearMonth, onChange }: useYearMonthPickerProps): useYearMonthPickerResult {
  const [{ transition, focus }, setState] = React.useState({
    transition: 'init' as 'none' | 'toNext' | 'toPrev' | 'init',
    focus: yearMonth ? yearMonth : YearMonthFns.toYearMonth(new Date())
  })

  const setFocus = React.useCallback(
    (internalFocus: string) => {
      setState((s) => {
        const isNext = internalFocus && focus > internalFocus
        const isPrev = internalFocus && focus < internalFocus
        console.log('internalFocus', internalFocus)
        if (isNext) {
          return {
            transition: 'toNext',
            focus: internalFocus
          }
        } else if (isPrev) {
          return {
            transition: 'toPrev',
            focus: internalFocus
          }
        } else {
          return {
            transition: 'none',
            focus: internalFocus
          }
        }
      })
    },
    [setState, focus]
  )

  const goToNext = React.useCallback(() => {
    setState((s) => ({
      transition: 'toNext',
      focus: YearMonthFns.getNextYear(s.focus)
    }))
  }, [setState])
  const goToPrev = React.useCallback(() => {
    setState((s) => ({
      transition: 'toPrev',
      focus: YearMonthFns.getPrevYear(s.focus)
    }))
  }, [setState])

  const onTransitionComplete = React.useCallback(() => {
    setState((s) => ({
      transition: 'none',
      focus: s.focus
    }))
  }, [setState])

  const yearMonthOptions = React.useMemo(() => {
    return YearMonthFns.getAllMonthsInYear(YearMonthFns.getYear(focus))
  }, [focus])

  return {
    goToNextYear: goToNext,
    goToPreviousYear: goToPrev,
    transitionState: transition,
    onTransitionComplete: onTransitionComplete,
    onChange,
    focus: focus,
    value: yearMonth,
    yearMonthOptions,
    setFocus
  }
}
